import { openModal, closeModal } from "./modal.js";

const menu = document.querySelector("#main-navigation");
const hamburger = document.querySelector("#hamburger");
const openIcon = hamburger?.querySelector(".menuIcon");
const closeIcon = hamburger?.querySelector(".closeIcon");

// Bail out on pages (e.g. the 404 template) that don't render the header/nav
if (menu && hamburger) {
  // Toggle nav
  hamburger.addEventListener("click", function () {
    menu.classList.contains("hidden") ? openNav() : closeNav();
  });

  // Close nav when a link is clicked
  menu.addEventListener("click", function (event) {
    if (event.target.tagName === "A") {
      closeNav();
    }
  });
}

const openNav = () => {
  if (!menu) return;
  openModal();
  menu.classList.remove("hidden");
  menu.classList.add("block", "opacity-100");
  openIcon.classList.add("hidden");
  closeIcon.classList.remove("hidden");
};

const closeNav = () => {
  if (!menu) return;
  closeModal();
  menu.classList.add("hidden");
  menu.classList.remove("block", "opacity-100");
  openIcon.classList.remove("hidden");
  closeIcon.classList.add("hidden");
};

// Re-applies the active link styling after a swup transition swaps in new page content
const updateActiveNavLinks = () => {
  if (!menu) return;
  const currentSegment =
    window.location.pathname.split("/").filter(Boolean)[0] ?? "";

  menu.querySelectorAll("a").forEach((link) => {
    const linkSegment = link.pathname.split("/").filter(Boolean)[0] ?? "";
    link.classList.toggle("!border-yellow", linkSegment === currentSegment);
  });
};

export { openNav, closeNav, updateActiveNavLinks };
